export default {
  state: {
    disable: false,
    show: false,
    chat_center_id: '',
  },
  getters: {
    isDisable: state => state.disable,
    isShow: state => state.show,
    chatCenterId: state => state.chat_center_id,
  },
  mutations: {
    SET_DISABLE(state, payload) {
      state.disable = payload;
    },
    SET_SHOW(state, payload) {
      state.show = payload;
    },
    SET_CHAT_CENTER_ID(state, payload) {
      state.chat_center_id = payload;
    },
  },
  actions: {
    CLOSE_SHOW_MODAL({commit}, payload) {
      commit('SET_SHOW', payload);
      if(!payload) {
        commit('SET_CHAT_CENTER_ID', '');
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/store/modules/chat_center_state.js